import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";
import FormField from "../components/FormField";

export const StepCoordonnees = () => (
  <div className="flex flex-col gap-3 step-enter">
    <div>
      <h2 className="text-base font-bold text-foreground">Coordonnées</h2>
      <p className="text-xs text-muted-foreground mt-0.5">
        Pour te joindre, t'envoyer les infos utiles et ta carte de membre si besoin.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-[2fr_1fr_1fr] gap-3">
      <FormField name="adressePostale" label="Adresse postale" icon={FaMapMarkerAlt} required />
      <FormField name="zipCode" label="Code postal" icon={FaMapMarkerAlt} required />
      <FormField name="city" label="Ville" icon={FaMapMarkerAlt} required />
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <FormField
        name="email"
        label="Adresse mail"
        icon={FaEnvelope}
        type="email"
        required
        help="Pour t'envoyer les infos, confirmations et actualités de l'association."
      />
      <FormField
        name="telephone"
        label="Téléphone"
        icon={FaPhone}
        type="tel"
        required
        help="Pour te joindre rapidement en cas d'urgence ou d'imprévu lors d'un événement."
      />
    </div>
  </div>
);
